<!--
  Harvesting 2.0 — le layout du module : navigation, et le point d'import unique
  de la feuille de style du module.

  PLUS DE RIDEAU (2026-10-27)
  Le module a quitté la Restricted Area pour le menu de gauche, à la place de
  l'ancien tableau de bord Harvesting : le code d'accès qui le tenait « en
  construction » à l'écart du passage n'a plus de raison d'être. L'accès reste
  réservé aux administrateurs par la règle de la route (router.js). Le nom du
  fichier est gardé pour ne pas toucher aux imports.

  CE QUI A DISPARU D'ICI
  Un vs-alert permanent listant les chantiers en cours était rendu sur TOUTES
  les routes du module et poussait chaque écran vers le bas, sans jamais pouvoir
  être replié. Cette information n'est pas perdue : elle est dans le repli
  « Comment c'est calculé » du tableau de bord, là où on la consulte quand on en
  a besoin plutôt que de la subir à chaque page.
-->
<template>
  <div id="harvesting2" class="hv2">
    <nav class="hv2-nav">
      <a
        v-for="tab in tabs"
        :key="tab.name"
        class="hv2-nav-item"
        :class="{ 'is-active': isActive(tab) }"
        role="button"
        tabindex="0"
        @click="go(tab)"
        @keyup.enter="go(tab)">
        <feather-icon :icon="tab.icon" svgClasses="h-4 w-4" />
        {{ tab.label }}
        <span v-if="tab.name === 'harvesting2-parcels' && pending" class="hv2-nav-count">
          {{ pending }}
        </span>
      </a>
      <span class="hv2-nav-spacer"></span>
      <span class="hv2-nav-note">Un APV, c'est du bois sur pied que nous achetons.</span>
    </nav>

    <router-view />
  </div>
</template>

<script>
import axios from '@/axios.js'

export default {
  data () {
    return {
      // Nombre d'APV que SUMAL connaît et que personne n'a encore encodés.
      // Une seule requête à l'entrée du module — elle ne touche pas au ROLLUP.
      pending: 0,
      tabs: [
        { name: 'harvesting2', label: 'Dashboard', icon: 'ActivityIcon' },
        { name: 'harvesting2-parcels', label: 'Les APV', icon: 'ListIcon' },
        { name: 'harvesting2-quality', label: 'Qualité & synchro', icon: 'ShieldIcon' }
      ]
    }
  },
  methods: {
    // L'onglet « Les APV » reste actif sur le détail d'une parcelle : sinon
    // ouvrir un APV éteint toute la barre et on ne sait plus où on est.
    isActive (tab) {
      if (tab.name === 'harvesting2-parcels') {
        return ['harvesting2-parcels', 'harvesting2-parcel', 'harvesting2-sumal'].indexOf(this.$route.name) !== -1
      }
      return this.$route.name === tab.name
    },
    go (tab) {
      if (this.$route.name !== tab.name) this.$router.push({ name: tab.name })
    },
    loadPending () {
      axios.get('/sumal2/pending')
        .then((r) => { this.pending = (r.data || []).length })
        .catch(() => { this.pending = 0 })
    }
  },
  created () {
    this.loadPending()
  }
}
</script>

<!--
  NON SCOPÉ, ET C'EST VOLONTAIRE.

  vs-table rend son DOM interne sous le data-v- de Vuesax, pas sous celui de la
  vue : un style scopé ne peut l'atteindre qu'avec ::v-deep répété dans chaque
  fichier. Cette feuille habille les quatorze tableaux du module en une fois.

  Tout y est préfixé .hv2 et ce composant est le layout de toutes les routes
  /harvesting2 : rien ne peut fuir ailleurs, et main.scss n'est pas touché — le
  CSS part avec le chunk de la route.
-->
<style lang="scss">
@import "@/assets/scss/modules/harvesting2.scss";
</style>
